import { useParams, useSearchParams } from "react-router-dom";
import {
  AcceptEmployeeInvitationMutation,
  AcceptUserInvitationMutation,
} from "types";

type InvitationData =
  | AcceptUserInvitationMutation["acceptUserInvitation"]
  | AcceptEmployeeInvitationMutation["acceptEmployeeInvitation"]
  | null;

type Options = {
  invitationData: InvitationData | undefined;
  /* Fallback for invitationId search param */
  invitationId?: string | null | undefined;
  /* Fallback for type search param */
  type?: string | null | undefined;
};

export const useNavigateAfterInvitation = () => {
  const { language } = useParams();
  const [searchParams] = useSearchParams();

  const getDestination = (options: Options): string => {
    const lang = language || "en";
    const type = searchParams.get("type") || options.type;

    if (!options.invitationData) {
      if (type === "employee") {
        return `/${lang}/employee`;
      } else {
        return `/${lang}/admin`;
      }
    }

    let companyId: string | undefined = undefined;

    if (type === "employee") {
      const invitationData =
        options.invitationData as AcceptEmployeeInvitationMutation["acceptEmployeeInvitation"];
      const employeeRole = (invitationData?.employments || []).find(
        (role) => role.company?.id,
      );
      companyId = employeeRole?.id;
    } else {
      const invitationData =
        options.invitationData as AcceptUserInvitationMutation["acceptUserInvitation"];
      const companyRole = (invitationData || []).find(
        (role) => role.company?.id,
      );
      companyId = companyRole?.company?.id;
    }

    if (type === "employee") {
      return `/${lang}/employee/overview`;
    }

    if (companyId) {
      return `/${lang}/admin/companies/${companyId}/dashboard/overview`;
    }

    return `/${lang}/admin`;
  };

  return getDestination;
};
